const keywords = [
  'and',
  'as',
  'assert',
  'break',
  'class',
  'continue',
  'def',
  'del',
  'elif',
  'else',
  'except',
  'False',
  'finally',
  'for',
  'from',
  'global',
  'if',
  'import',
  'in',
  'is',
  'lambda',
  'None',
  'nonlocal',
  'not',
  'or',
  'pass',
  'raise',
  'return',
  'True',
  'try',
  'while',
  'with',
  'yield'
]

const classes = ['sys', 'os', 'math', 'random', 'collections', 'itertools']

const functions = [
  'acos',
  'append',
  'argv',
  'asin',
  'atan',
  'accumulate',
  'bool',
  'bytes',
  'chain',
  'ceil',
  'chdir',
  'ChainMap',
  'complex',
  'copy',
  'combinations',
  'clear',
  'cos',
  'choice',
  'cycle',
  'Counter',
  'defaultdict',
  'deque',
  'dict',
  'dropwhile',
  'extend',
  'exit',
  'exp',
  'fabs',
  'floor',
  'filterfalse',
  'float',
  'getcwd',
  'getdefaultencoding',
  'getsizeof',
  'groupby',
  'index',
  'int',
  'islice',
  'insert',
  'list',
  'log',
  'listdir',
  'mkdir',
  'namedtuple',
  'OrderedDict',
  'path',
  'platform',
  'permutations',
  'pop',
  'product',
  'print',
  'randint',
  'random',
  'range',
  'rename',
  'rmdir',
  'remove',
  'repeat',
  'reverse',
  'remove',
  'sample',
  'sin',
  'set',
  'sort',
  'setrecursionlimit',
  'sqrt',
  'shuffle',
  'str',
  'stdin',
  'stdout',
  'stderr',
  'tan',
  'tuple',
  'type',
  'takewhile',
  'uniform',
  'version',
  'zip_longest'
]
export default {
  keywords,
  classes,
  functions
}
